import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "../login/login.css";
import "../landing/landing.css";
import "./Instructions.css";
import { s3PublicUrl } from "../../utils/s3PublicUrl";

function readGameSettings() {
  try {
    return JSON.parse(sessionStorage.getItem("gameSettings") || "{}") || {};
  } catch {
    return {};
  }
}

/** Shown once, right after War Cry recording and before the Waiting Room — the admin's
 * player-instructions points (Game Basics step) as a plain bulleted list. */
function Instructions() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useSelector((state) => state.theme);

  const headingColor = data?.headingColor || "#D83307";
  const textColor = data?.textColor || "#5B5B5B";
  const buttonBg = data?.buttonBgColor || "#D83307";
  const buttonText = data?.buttonTextColor || "#FFFFFF";
  const rawCover = data?.background_mob || data?.hunt_cover_image || data?.background_desk;
  const coverImage = rawCover ? s3PublicUrl(rawCover) : "";

  useEffect(() => {
    document.body.classList.add("login-static-bg");
    if (coverImage) {
      document.body.style.backgroundImage = `url("${encodeURI(coverImage)}")`;
    }
    return () => {
      document.body.classList.remove("login-static-bg");
      document.body.style.backgroundImage = "";
    };
  }, [coverImage]);

  const gameSettings = useMemo(readGameSettings, []);
  const stageId = location.state?.stageId ?? gameSettings.stageId ?? null;
  const themeName = location.state?.themeName ?? gameSettings.themeName ?? "theme0";

  const points = (data?.instructions || []).filter((p) => String(p || "").trim());

  const handleContinue = () => {
    navigate("/waiting-room", { replace: true, state: { stageId, themeName } });
  };

  return (
    <div className="landing-page instructions-page">
      <div className="landing-content instructions-content">
        <h1 className="instructions-title" style={{ color: headingColor }}>
          Instruction
        </h1>

        <ul className="instructions-list" style={{ color: textColor }}>
          {points.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>

        <button
          type="button"
          className="landing-play-btn"
          style={{ background: buttonBg, color: buttonText }}
          onClick={handleContinue}
        >
          Continue
        </button>

        <div className="landing-footer">Powered by ExtraMile Play</div>
      </div>
    </div>
  );
}

export default Instructions;
